import { error, finish } from '../../../modules/ladders/actions/updateSportLadder';
import api from '../../../api';

export function request(dispatch, { sportId, ladder }) {
    // api.post(`/ladders/${sportId}`, ladder, { cache: true }).then(
    //     ladder => dispatch(finish(sportId, ladder)),
    //     ({ errors }) => dispatch(error(sportId, errors))
    // );
    const requestBody = { prices: ladder.prices, sport_id: sportId };

    $appState.sdkStaff.trading.patchPriceLadderByKey( {requestBody} )
        .then(data => dispatch(finish(sportId, data)))
        .catch(errors => dispatch(error(sportId, errors)));
}
